import { lazy } from 'react';
import Loadable from '../../components/Loadable';

const Whatsapp = Loadable(lazy(() => import('./Whatsapp')));

const whatsappRoutes = [{ path: '/whatsapp', element: <Whatsapp /> }];

export default whatsappRoutes;
